<ni-card [headerBgColor]="'gray'" title="Fuel Transaction Count at Nearby Airports">
    <div class="flex">
        <div class="d-inline-block mr-2 ml-2">
            <app-preset-date-filter
                [defaultFilter]="selectedFilter"
                (selectedFilterChange)="applyPresetDateFilter($event)"
            ></app-preset-date-filter>
        </div>
        <div>
            <div class="d-inline-block mr-2 ml-2" style="width: 130px">
                <mat-form-field>
                    <input
                        (dateChange)="applyCustomDateFilter()"
                        (focus)="dashboardSettingsStartDateFilter.open()"
                        [(ngModel)]="filterStartDate"
                        [matDatepicker]="dashboardSettingsStartDateFilter"
                        [max]="filterEndDate"
                        matInput
                        placeholder="Start Date"
                    />
                    <mat-datepicker-toggle
                        [for]="dashboardSettingsStartDateFilter"
                        matSuffix
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                        #dashboardSettingsStartDateFilter
                        disabled="false"
                    ></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="d-inline-block mr-2 ml-2" style="width: 130px">
                <mat-form-field>
                    <input
                        (dateChange)="applyCustomDateFilter()"
                        (focus)="dashboardSettingsEndDateFilter.open()"
                        [(ngModel)]="filterEndDate"
                        [matDatepicker]="dashboardSettingsEndDateFilter"
                        [min]="filterStartDate"
                        matInput
                        placeholder="End Date"
                    />
                    <mat-datepicker-toggle
                        [for]="dashboardSettingsEndDateFilter"
                        matSuffix
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                        #dashboardSettingsEndDateFilter
                        disabled="false"
                    ></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="mile-section">
        <label>Miles: </label>
        <mat-slider
            (change)="changeMile($event)"
            [value]="mile"
            max="200"
            min="0"
            thumbLabel
            tickInterval="1"
            style="width: 50%;"
        ></mat-slider>
    </div>
    <div class="chart-container">
        <ngx-charts-bar-vertical
            *ngIf="totalOrdersData"
            [gradient]="false"
            [legend]="false"
            [results]="totalOrdersData"
            [scheme]="colorScheme"
            [xAxis]="true"
            [yAxis]="true"
        ></ngx-charts-bar-vertical>
    </div>
    <!-- <div class="distance-selector">
        <label>Miles: </label>
        <mat-slider
            thumbLabel
            tickInterval="1"
            min="0"
            max="200"
            [value]="mile"
            (change)="changeMile($event)"
        ></mat-slider>
    </div> -->
    <ngx-ui-loader
        [loaderId]="chartName"
        bgsColor="rgb(100, 181, 246)"
        bgsPosition="center-center"
        bgsType="ball-spin"
        overlayColor="rgba(0, 0, 0, 0.1)"
    ></ngx-ui-loader>
</ni-card>
